import { useThemeName } from "../useThemeName/useThemeName.mjs";
const ThemeNameConsumer = ({ children }) => children(useThemeName());
export {
  ThemeNameConsumer
};
